import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import HTMLToPdfSelectHTMLView from "./HTMLToPdfSelectHTMLView";
import HTMLToPdfOutputSettingsView from "./HTMLToPdfOutputSettingsView";
import {
  blobToFile,
  desiredDPI,
  formatBytes,
  imageDimension,
  loadFromURLAsBlob,
} from "../Utils";
import NUpOutputOrientation from "../pdf_n_up_tool/NUpOutputOrientation";
import HTMLToPDFTabs from "./HTMLToPDFTabs";
import { BASE_URL, REQUEST_URL, STATUS_CHECK_INTERVAL } from "../Config";
import {
  createAPIRequest,
  getSignedAWSS3URLToDownloadFile,
  getSignedAWSS3URLToUploadFile,
  uploadFileToAWSS3Server,
} from "../WebUtils";

function HTMLToPdfMain() {
  //max file size
  //max .html, .css file size
  const MAX_FILE_SIZE = 2 * 1024 * 1024; //in bytes
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "HTML To PDF Converter Free" };

  //html content
  const [html2ImageDetails, setHtml2ImageDetails] = useState({
    state: AppState.NONE,
    webpageURL: "", //requires when convertimg frol url
    htmlFile: null, //requires when convertimg frol html file
    htmlCode: "", //requires when convertimg frol html code
    selectedTab: HTMLToPDFTabs.TAB_CONVERT_WEBPAGE,
    message: "",
  });
  //image file
  const [imageDetails, setImageDetails] = useState({
    imageBlob: null,
    imageDimension: { width: 0, height: 0 },
  });
  //export file details
  const [exportFileDetails, setExportFileDetails] = useState({
    password: "",
    width: Math.floor(8.3 * desiredDPI), //a4 page dimension
    height: Math.floor(11.7 * desiredDPI), //a4 page dimension
    compress: true,
    pageLayout: "A4",
    exportPageLayoutPopupShowing: false,
    linked: true,
    filename: "html_to_pdf",
    output_orientation: NUpOutputOrientation.PORTRAIT,
    exportOrientationPopupShowing: false,
  });
  //is converting
  const [isConverting, setIsConverting] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/html_to_pdf", title: "Convert Webpage To PDF Free" },
    data2: { link: "/html_to_pdf", title: "HTML To PDF Converter Online" },
    data3: { link: "/html_to_pdf", title: "Convert HTML To PDF Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (isConverting === true) {
      //set processig
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.PROCESSING,
        message: "",
      });
      //convert
      convertHTMLToImage(REQUEST_URL);
    } else {
      //set progress
      setProgress(100);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConverting]);

  //check status from status from endpoint
  const checkRunpodJobStatus = async (url, job_id) => {
    //check runpod status
    //access token append automatically
    const response = await createAPIRequest(url, "POST", "application/json", {
      request_type: "STATUS_CHECK_HTML_TO_IMAGE",
      job_id: job_id,
    });

    //check
    if (response === null) {
      //set message
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.NONE,
        message: "Network error. Check your internet connection and try again.",
      });
      //set
      setIsConverting(false);
      //return
      return;
    }

    console.log("Response: ", response);

    //check success
    if (response !== null && response.success === true) {
      //check status
      if (response.status === "COMPLETED") {
        //try ctach
        try {
          //resobj
          const convObj = JSON.parse(response.message);
          //image name
          const image_name = convObj.output_file;
          console.log("Image name: ", image_name);

          //check
          if (image_name !== "") {
            //get image url
            const imageDownloadUrlResponse =
              await getSignedAWSS3URLToDownloadFile(url, image_name);
            //check
            if (
              imageDownloadUrlResponse !== null &&
              imageDownloadUrlResponse.success === true
            ) {
              //set output message
              setHtml2ImageDetails({
                ...html2ImageDetails,
                state: AppState.PROCESSED,
                message: "Successfully captured html.",
              });

              //url to blob
              const imgBlob = await loadFromURLAsBlob(
                imageDownloadUrlResponse.downloadUrl,
              );
              //get image dimension
              const imgDimension = await imageDimension(
                blobToFile(imgBlob),
                "html_to_image.jpeg",
              );
              //set image details
              setImageDetails({
                ...imageDetails,
                imageBlob: await loadFromURLAsBlob(
                  imageDownloadUrlResponse.downloadUrl,
                ),
                imageDimension: {
                  width: Number(imgDimension[0]),
                  height: Number(imgDimension[1]),
                },
              });
              //set
              setIsConverting(false);
            } else {
              //set
              setHtml2ImageDetails({
                ...html2ImageDetails,
                state: AppState.NONE,
                message: "Sorry, failed downloading file.",
              });
              //set
              setIsConverting(false);
            }
            console.log("Response: ", imageDownloadUrlResponse);
          } else {
            //set
            setHtml2ImageDetails({
              ...html2ImageDetails,
              state: AppState.NONE,
              message: "Sorry, failed downloading file.",
            });
            //set
            setIsConverting(false);
          }
        } catch {
          //set
          setHtml2ImageDetails({
            ...html2ImageDetails,
            state: AppState.NONE,
            message: "Sorry, failed processing file.",
          });
          //set
          setIsConverting(false);
        }
      } else if (
        response.status === "FAILED" ||
        response.status === "CANCELLED" ||
        response.status === "TIMED_OUT"
      ) {
        //set message
        setHtml2ImageDetails({
          ...html2ImageDetails,
          state: AppState.NONE,
          message:
            response.message === null
              ? "Sorry we couldn't process your request. Invalid request."
              : response.message,
        });

        //set
        setIsConverting(false);
      } else if (
        response.status === "IN_QUEUE" ||
        response.status === "RUNNING" ||
        response.status === "IN_PROGRESS"
      ) {
        //check api after 10 seconds
        setTimeout(() => {
          //callback
          checkRunpodJobStatus(url, job_id);
        }, STATUS_CHECK_INTERVAL);
      }
    } else {
      //set
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.NONE,
        message: "Sorry, failed processing file.",
      });
      //set
      setIsConverting(false);
    }
  };

  //convert html to image
  //url = REQUEST_URL
  const convertHTMLToImage = async (url) => {
    //check html file size
    if (
      html2ImageDetails.htmlFile !== null &&
      html2ImageDetails.htmlFile.size > MAX_FILE_SIZE
    ) {
      //set message
      setHtml2ImageDetails({
        ...html2ImageDetails,
        message: `Sorry, we can’t process this file because it exceeds the maximum size limit. Please upload a smaller file. The maximum allowed size is - ${formatBytes(MAX_FILE_SIZE)}`,
      });
      //set
      isConverting(false);
      //return
      return;
    }

    //set progress
    setProgress(30);

    //filename
    let uploadFileName = "";
    //check if html file is not null
    if (
      html2ImageDetails.selectedTab === HTMLToPDFTabs.TAB_CONVERT_HTML_FILE &&
      html2ImageDetails.htmlFile !== null
    ) {
      //get signed aws s3 url
      const response = await getSignedAWSS3URLToUploadFile(
        url,
        html2ImageDetails.htmlFile,
      );

      //check
      if (response !== null && response.success === true) {
        //upload file
        const uploadUrl = response.uploadUrl;
        //check
        if (uploadUrl !== null) {
          //upload file
          const fileUploadResponse = await uploadFileToAWSS3Server(
            uploadUrl,
            html2ImageDetails.htmlFile,
          );

          //check response
          if (fileUploadResponse !== null && fileUploadResponse.ok === true) {
            //filename
            //set upload filename
            uploadFileName = response.fileName;
          } else {
            //set message
            setHtml2ImageDetails({
              ...html2ImageDetails,
              state: AppState.NONE,
              message: "Sorry, failed uploading file. Please try again later.",
            });
            //set
            setIsConverting(false);
            //retutn
            return;
          }
        } else {
          //set
          setIsConverting(false);
          //retutn
          return;
        }
      } else {
        //set message
        setHtml2ImageDetails({
          ...html2ImageDetails,
          state: AppState.NONE,
          message:
            response === null
              ? "Network error. Check your internet connection and try again."
              : response.message,
        });
        //set
        setIsConverting(false);
        //retutn
        return;
      }

      //set progress
      setProgress(50);
    }

    //call runpod code
    //call html to image endpoint
    //access token append automatically
    const response = await createAPIRequest(url, "POST", "application/json", {
      request_type: "HTML_TO_IMAGE",
      convert_type: html2ImageDetails.selectedTab.toString(),
      htmlCode: html2ImageDetails.htmlCode,
      webpageURL: html2ImageDetails.webpageURL,
      html_file_name: uploadFileName,
      job_id: null,
    });

    //set progress
    setProgress(70);

    //check
    if (response === null) {
      //set message
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.NONE,
        message: "Network error. Check your internet connection and try again.",
      });
      //set
      setIsConverting(false);
      //return
      return;
    }

    console.log("Response: ", response);

    //check
    //if failed
    if (response.success === false) {
      //set message
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.NONE,
        message: response.message,
      });
      //set
      setIsConverting(false);
    } else {
      //set token in local storage
      localStorage.setItem("access_token", response.token);
      //set job_id
      const job_id = response.job_id;
      //check response from runpod server
      //when humanize text is completed
      if (
        response.status === "FAILED" ||
        response.status === "CANCELLED" ||
        response.status === "TIMED_OUT" ||
        job_id === null
      ) {
        //set message
        setHtml2ImageDetails({
          ...html2ImageDetails,
          state: AppState.NONE,
          message:
            response.message === null
              ? "Sorry we couldn't process your request. Invalid request."
              : response.message,
        });

        //set
        setIsConverting(false);
      } else {
        //check status for job_id
        checkRunpodJobStatus(url, job_id);
      }
    }
  };

  return (
    <PageContext.Provider
      value={{
        html2ImageDetails,
        setHtml2ImageDetails,
        isConverting,
        setIsConverting,
        imageDetails,
        setImageDetails,
        exportFileDetails,
        setExportFileDetails,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title + " Online"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert HTML to PDF online instantly. Transform web pages, websites, or code into secure, high quality PDFs quickly with our HTML to PDF tool."
      ></meta>
      <meta
        name="keywords"
        content="HTML to PDF, convert HTML to PDF, online HTML to PDF, web page to PDF, website to PDF, HTML file to PDF, HTML PDF converter, HTML to PDF online, convert web page to PDF, HTML document to PDF, online PDF converter, web to PDF, HTML PDF tool, HTML page to PDF, PDF conversion tool, html code to pdf, code to pdf, html text to pdf,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Select HTML View */}
        <HTMLToPdfSelectHTMLView
          selectMultiple={false}
        ></HTMLToPdfSelectHTMLView>
        {/* Output Settings */}
        <HTMLToPdfOutputSettingsView></HTMLToPdfOutputSettingsView>
        {/* Mid Section */}
        <MiscPageMidSection description="Our HTML to PDF Converter website offers a fast, reliable, and secure way to transform HTML files and web content into high quality PDF documents without requiring an internet connection. Built to support full offline functionality, this powerful tool allows users to convert HTML to PDF directly on their device, ensuring maximum privacy and data security. Whether you are working with local HTML files, project documentation, invoices, or reports, this solution delivers accurate rendering with preserved layouts, fonts, images, and styles. The platform supports both offline and online workflows, making it flexible for users who prefer HTML to PDF online conversion when needed. With an intuitive interface, users can easily use this HTML to PDF converter to convert webpages to PDF or turn local HTML content into professional PDFs for sharing, printing, or archiving. Advanced rendering ensures that CSS, links, and page structures remain intact, providing consistent results every time you convert HTML to PDF online or offline. Ideal for developers, designers, students, and businesses, this website simplifies documentation and content distribution while maintaining high output quality. If you are searching for a secure and efficient HTML to PDF converter, a dependable way to convert webpages to PDF, or a privacy focused solution for HTML to PDF conversion with offline support, this platform delivers a seamless experience designed for modern users." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Offline",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="HTML To PDF Converter"
          why_use={[
            {
              title: "Convert Web Pages into Portable PDFs",
              description:
                "HTML to PDF allows you to convert web pages and HTML files into portable PDF documents that are easy to share and store.",
            },
            {
              title: "Preserve Layout and Styling",
              description:
                "When you convert HTML to PDF, the original layout, CSS styles, fonts, and images remain intact in the final document.",
            },
            {
              title: "Create Print Ready Documents",
              description:
                "Using HTML to PDF online or offline helps generate clean, print ready PDFs for reports, invoices, and records.",
            },
            {
              title: "Offline Conversion for Privacy and Security",
              description:
                "Our offline HTML to PDF solution processes files locally, keeping sensitive content secure without uploading data online.",
            },
            {
              title: "Ideal for Developers and Businesses",
              description:
                "Developers and businesses rely on HTML to PDF to create documentation, contracts, invoices, and automated reports.",
            },
            {
              title: "Universal Compatibility Across Devices",
              description:
                "PDFs created using HTML to PDF online open consistently on all devices, browsers, and operating systems.",
            },
            {
              title: "Archive Web Content for Offline Access",
              description:
                "With convert webpages to PDF, important online content can be saved for offline viewing and long term storage.",
            },
            {
              title: "Save Time with Automated Conversion",
              description:
                "HTML to PDF tools eliminate manual formatting and make it faster to convert web content into PDFs.",
            },
            {
              title: "Consistent Output Quality",
              description:
                "Whether you convert HTML to PDF online or offline, the output quality and formatting remain consistent.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default HTMLToPdfMain;
